import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Params = {
  territoryId: string
  name: string
}

export const renameTerritory = createAsyncThunk<
  // Return type of the payload creator
  boolean,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/rename', async (params: Params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/renameTerritory', {
      category: 'rpc',
      type: 'rpc/territory/renameTerritory',
      payload: params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
    return true
  } catch (error) {
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Rename Territory Failed',
      error,
    })
  }
})
